import { ButtonHTMLAttributes, FC, ReactNode } from 'react';
import { PunchupButton } from 'features/common/components/Punchup/primitives/buttons/PunchupButton';

interface PunchupActionButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
	/** Legacy text prop — mirrors PunchupButton API. */
	text?: string;
	children?: ReactNode;
}

/**
 * @deprecated Use `<PunchupButton variant="outline">` directly.
 * This wrapper exists for backward compatibility with existing callsites.
 */
export const PunchupActionButton: FC<PunchupActionButtonProps> = (props) => (
	<PunchupButton variant="outline" {...props} />
);
